import { Box, Grid, Text } from '@chakra-ui/react';
import Image from 'next/image';

const LogoBox = ({ src }) => {
  return (
    <Box flex={1} h="60px" position="relative" overflow="hidden">
      <Image src={src} alt="Humana logo." fill style={{ padding: '8px' }} />
    </Box>
  );
};

const Carriers = () => (
  <Box mt={10}>
    <Text ml={2} mb={[0, 3]} mt={[3, 3, 0]} textStyle="p" fontWeight={500}>
      Plans from the following carriers and more:
    </Text>
    <Grid w="100%" gap={4} templateColumns={['1fr', '1fr 1fr', 'repeat(4, 1fr)']}>
      <LogoBox src="wellcare.svg" />
      <LogoBox src="aetna.svg" />
      <LogoBox src="cigna.svg" />
      <LogoBox src="anthem.svg" />
    </Grid>
  </Box>
);

export default Carriers;
